var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowClockwise(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3.5v3a.75.75 0 01-.75.75h-3a.75.75 0 110-1.5h1.069L11.88 4.664l-.024-.023a4.75 4.75 0 10-3.42 8.11H8.5a4.721 4.721 0 003.26-1.296.75.75 0 111.03 1.09A6.216 6.216 0 018.5 14.25h-.086a6.25 6.25 0 114.493-10.684l1.343 1.23V3.5a.75.75 0 111.5 0z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClockwise);
export default "/_next/static/images/fc62852ba85a73e593e56cd9020a69c7.svg";
export { ForwardRef as ReactComponent };